import React from "react";

export default function ML_Languages() {
  return (
    <div>
      <h1>ML_Languages</h1>
      <p>This is the ML_Languages component.</p>
    </div>
  );
}
